import React from 'react';
import PropTypes from 'prop-types';
import { Div, TextAreaStyled } from './textAreaStyles';

class TextArea extends React.Component {
  constructor() {
    super();
    this.onChange = this.onChange.bind(this);
  }
  onChange(e) {
    this.props.onChange({
      [this.props.name]: e.target.value,
    });
  }

  render() {
    const { value, label, disabled } = this.props;
    return (
      <Div>
        <label>{label}</label><br />
        <TextAreaStyled
          value={value}
          onChange={this.onChange}
          disabled={disabled}
        />
      </Div>
    );
  }
}

TextArea.propTypes = {
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
};

TextArea.defaultProps = {
  value: '',
};

export default TextArea;
